export default {
  app: {
    title: '壁纸精选',
    tagline: '搜索数万张高清壁纸',
    searchPlaceholder: '搜索你喜欢的壁纸...',
    hotRecommend: '热门推荐',
    searchResult: '搜索结果',
    noMore: '没有更多了',
    loadFailed: '加载失败',
    retry: '重试',
    noWallpapers: '暂无壁纸',
    noResults: '未找到相关壁纸',
    tryOtherKeywords: '尝试使用其他关键词搜索',
    categoryPrefix: '分类',
    download: '下载壁纸',
    preview: '预览',
    close: '关闭',
    noWallpapersInCategory: '该分类暂无壁纸',
    timeout: '请求超时，请检查网络后重试',
    notFound: '页面未找到',
    backHome: '返回首页',
    dataSource: '数据来源',
    allRightsReserved: 'All rights reserved.',
    search: '搜索',
    darkMode: '深色模式',
    lightMode: '浅色模式',
    switchLang: '切换语言',
  },
  theme: {
    default: '默认蓝',
    sunset: '日落橙',
    forest: '森林绿',
    ocean: '海洋青',
    lavender: '薰衣草紫',
    cherry: '樱花粉',
  },
};
